import { render } from "./DashboardBoxShortcut.vue?vue&type=template&id=906361da"
import script from "./DashboardBoxShortcut.vue?vue&type=script&lang=js"
export * from "./DashboardBoxShortcut.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__